import { useSetAtom as t, useAtomValue as e } from "jotai";
import { setClientDetailsAtom as i, selectedClientDetailsAtom as l } from "./index55.mjs";
const m = () => ({
  setClientDetails: t(i),
  clientDetails: e(l)
});
export {
  m as useClientDetails
};
